import correctSoundUrl from "@mobile/assets/correct.mp3";
import incorrectSoundUrl from "@mobile/assets/incorrect.mp3";

import { playWebAudio } from "./webAudio";

export type WebFeedbackOutcome = "PASS" | "LOW_SCORE" | "FAIL" | "correct" | "incorrect";

export async function playWebFeedbackSound(outcome: WebFeedbackOutcome): Promise<boolean> {
  if (outcome === "LOW_SCORE") {
    return false;
  }
  const soundUrl = outcome === "PASS" || outcome === "correct"
    ? correctSoundUrl
    : incorrectSoundUrl;

  try {
    return await playWebAudio(soundUrl);
  } catch {
    // Feedback audio is additive and must never block retry or progression.
    return false;
  }
}
